import { computed } from 'vue';
import {
  canUpdateMidas,
  isLaudoRegisteringItem as isLaudoRegisteringItemFor,
  isRefusalActionVisible,
  isRegisterActionVisible,
  registerButtonTitle as registerButtonTitleFor,
} from '../utils/pendentesFormatters';

/**
 * Shared per-row action guards for the pendentes list surfaces (cards + table).
 * Keeps the exact disabled/title rules the page applied before extraction.
 */
export function usePendentesRowActions({
  updatingMidasItemId,
  registeringLaudoItemId,
  savingRefusalItemId,
}) {
  const isUpdatingMidas = computed(() => Boolean(updatingMidasItemId.value));
  const isRegisteringLaudo = computed(() =>
    Boolean(registeringLaudoItemId.value)
  );
  const isSavingRefusal = computed(() => Boolean(savingRefusalItemId.value));

  function isLaudoRegisteringItem(item) {
    return isLaudoRegisteringItemFor(item, registeringLaudoItemId.value);
  }

  function registerButtonTitle(item) {
    return registerButtonTitleFor(item, registeringLaudoItemId.value);
  }

  function isMidasButtonDisabled(item) {
    return isUpdatingMidas.value || !canUpdateMidas(item);
  }

  function isRegisterButtonDisabled(item) {
    return (
      isRegisteringLaudo.value ||
      isLaudoRegisteringItem(item) ||
      !isRegisterActionVisible(item)
    );
  }

  function isRefusalButtonDisabled(item) {
    return isSavingRefusal.value || !isRefusalActionVisible(item);
  }

  return {
    isLaudoRegisteringItem,
    registerButtonTitle,
    isMidasButtonDisabled,
    isRegisterButtonDisabled,
    isRefusalButtonDisabled,
  };
}
